"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormPercentage", {
    enumerable: true,
    get: function() {
        return FormPercentage;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const DEFAULT_MIN = 0;
const DEFAULT_MAX = 999;
const FormPercentage = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>{
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors, animationDuration } = (0, _Theme.useTheme)();
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        rounded: props.rounded
    });
    const padding = (0, _useInputPadding.useInputPadding)();
    var _props_value;
    const [internalValue, setInternalValue] = (0, _react.useState)((_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : "");
    const sanitise = (rawValue)=>{
        let value = rawValue.replace(/\D/gu, "");
        const num = Number(value);
        var _props_min;
        const min = Number((_props_min = props.min) !== null && _props_min !== void 0 ? _props_min : DEFAULT_MIN);
        var _props_max;
        const max = Number((_props_max = props.max) !== null && _props_max !== void 0 ? _props_max : DEFAULT_MAX);
        if (num < min) {
            value = String(min);
        }
        if (num > max) {
            value = String(max);
        }
        return value;
    };
    var _props_className, _props_id, _props_value1;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "2420ab89b3d7688e",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    props.variant === "lg" ? "24px" : "22px",
                    animationDuration,
                    colors.muted1
                ]
            ]
        ]) + " " + "input-percentage ".concat((_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "", " ").concat(borderCss.className)
    }, /*#__PURE__*/ _react.default.createElement("input", {
        ...props,
        type: "number",
        ref: ref,
        id: (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id,
        "aria-describedby": hintId,
        value: (_props_value1 = props.value) !== null && _props_value1 !== void 0 ? _props_value1 : internalValue,
        onKeyDown: (e)=>{
            e.currentTarget.value = sanitise(e.currentTarget.value);
            if (props.onKeyDown != null) {
                props.onKeyDown(e);
            }
        },
        onInput: (e)=>{
            e.currentTarget.value = sanitise(e.currentTarget.value);
            if (props.onInput != null) {
                props.onInput(e);
            }
        },
        onChange: (e)=>{
            e.currentTarget.value = sanitise(e.currentTarget.value);
            setInternalValue(e.target.value);
            if (props.onChange != null) {
                props.onChange(e);
            }
        },
        onBlur: (e)=>{
            e.currentTarget.value = sanitise(e.currentTarget.value);
            setInternalValue(e.currentTarget.value);
            if (props.onBlur != null) {
                props.onBlur(e);
            }
        },
        className: _style.default.dynamic([
            [
                "2420ab89b3d7688e",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    props.variant === "lg" ? "24px" : "22px",
                    animationDuration,
                    colors.muted1
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }), /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "2420ab89b3d7688e",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "16px" : "14px",
                    props.variant === "lg" ? "24px" : "22px",
                    animationDuration,
                    colors.muted1
                ]
            ]
        ])
    }, "%")), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "2420ab89b3d7688e",
        dynamic: [
            padding.shorthand,
            props.variant === "lg" ? "16px" : "14px",
            props.variant === "lg" ? "24px" : "22px",
            animationDuration,
            colors.muted1
        ]
    }, ".input-percentage.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:".concat(padding.shorthand, ";font-size:").concat(props.variant === "lg" ? "16px" : "14px", "!important;line-height:").concat(props.variant === "lg" ? "24px" : "22px", "!important}input.__jsx-style-dynamic-selector{border:0;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;cursor:pointer;outline:none;-webkit-transition:").concat(animationDuration, " box-shadow,border;-moz-transition:").concat(animationDuration, " box-shadow,border;-o-transition:").concat(animationDuration, " box-shadow,border;transition:").concat(animationDuration, " box-shadow,border;width:100%;position:relative;background:#fff;text-align:right}input.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector:-moz-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector::-moz-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector:-ms-input-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector::-ms-input-placeholder{color:").concat(colors.muted1, "}input.__jsx-style-dynamic-selector::placeholder{color:").concat(colors.muted1, "}")), borderCss.styles);
});
FormPercentage.displayName = "FormPercentage";

//# sourceMappingURL=FormPercentage.js.map